import { Route, Routes, useLocation } from "react-router-dom";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Index from "./pages";
import AboutUs from "./pages/aboutus";
import Services from "./pages/services";
import Blog from "./pages/blogs";
import BlogDetails from "./pages/blog-detail";
import ContactUs from "./pages/contactus";
import Pay from "./pages/sidom-pay";
import Isurance from "./pages/sidom-insurance";
import Misim from "./pages/sidom-misim";
import SmartReader from "./pages/sidom-smart-reader";
import Eventos from "./pages/sidom-eventos";
import AccesoAcliente from "./pages/sidom-acceso-cliente";
import Mre from "./pages/sidom-mre";
import Novedades from "./pages/sidom-novedades";
import Ejemplo1 from "./pages/ejemplo1";
import Ejemplo2 from "./pages/ejemplo2";
import Ejemplo3 from "./pages/ejemplo3";
import PrivacyPolicy from "./components/PrivacyPolicy";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import PrivateRoute from "./components/PrivateRoute";
import MetaPixel from "./components/MetaPixel";
import GoogleAnalytics from "./components/GoogleAnalytics";
import GoogleAds from "./components/GoogleAds";

function App() {
  const location = useLocation();
  useEffect(() => {
    AOS.init({ duration: 800, once: false });
  }, []);
  useEffect(() => {
    AOS.refresh();
  }, [location]);
  return (
    <div className="App">
      {/** Tracking --> */}
      <MetaPixel />
      <GoogleAnalytics />
      <GoogleAds />
      {/** Tracking */}
      <Routes>
        <Route path="/" element={<Index />} />

        <Route path="/aboutUs" element={<AboutUs />} />
        <Route path="/services" element={<Services />} />
        <Route path="/blogs" element={<Blog />} />
        <Route path="/blog-detail" element={<BlogDetails />} />
        <Route path="/blog-detail/:id" element={<BlogDetails />} />
        <Route path="/contactus" element={<ContactUs />} />

        {/** rutas sidom */}
        <Route path="/sidom-pay" element={<Pay />} />
        <Route path="/sidom-insurance" element={<Isurance />} />
        <Route path="/sidom-misim" element={<Misim />} />
        <Route path="/sidom-smart-reader" element={<SmartReader />} />
        <Route path="/sidom-eventos" element={<Eventos />} />
        <Route path="/sidom-acceso-clientes" element={<AccesoAcliente />} />
        <Route path="/sidom-mre" element={<Mre />} />
        <Route path="/sidom-novedades" element={<Novedades />} />

        <Route path="/ejemplo1" element={<Ejemplo1 />} />
        <Route path="/ejemplo2" element={<Ejemplo2 />} />
        <Route path="/ejemplo3" element={<Ejemplo3 />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        {/** -----------------------------------------------*/}

        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
      </Routes>
    </div>
  );
}

export default App;
